module.exports = __webpack_public_path__ + "img/btn5.4b0c62e9.png";